import { useContext } from 'react'

import { AosTokenContext } from '../../providers/'

export function useAosToken() {
  const { token } = useContext(AosTokenContext)
  return token
}
